export default [
  {
    title: '',
    path: '',
    redirect: 'default'
  },
  {
    title: '玉玦图',
    path: 'default',
    component: () => import('./radialBar.md')
  }
]
